import { getFontSize } from '../../../../../constants/fontSizes';

export const testimonialCardStyles = {
  card: {
    width: {xs: '100%', lg: '350px', xl: '400px'},
    backgroundColor: '#FCFCFC0D',
    borderRadius: '40px',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: "100%",
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
  },
  title: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: getFontSize(18),
    lineHeight: {xs: '18px', md: '22px', lg: '26px', xl: '28px'},
    color: '#BCA08A',
  },
  review: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(26),
    lineHeight: {xs: '25px', lg: '32px'},
    letterSpacing: '-0.01em',
    color: 'secondary.main',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  icon: {
    color: '#BCA08A',
    fontSize: getFontSize(40),
  },
  bottomInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    marginTop: {xs: '5px', lg: '16px'},
  },
  name: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(18),
    letterSpacing: 0,
    color: 'secondary.main',
  },
  location: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: getFontSize(14),
    letterSpacing: 0,
    color: 'secondary.main',
  },
};

